module.exports = __webpack_public_path__ + "media/images/setting/icon6-0f1a70d1191a3f03d2db8caf57a6ddd1.svg";